"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _constants = require("../../utils/constants");
var _Backdrop = _interopRequireDefault(require("@material-ui/core/Backdrop"));
var _excluded = ["blur", "background"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FrostedBackdrop = function FrostedBackdrop(_ref) {
  var _ref$blur = _ref.blur,
    blur = _ref$blur === void 0 ? 8 : _ref$blur,
    background = _ref.background,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var StyledBackdrop = (0, _react.useMemo)(function () {
    return (0, _styles.withStyles)(function (_ref2) {
      var palette = _ref2.palette;
      return (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, "@supports not ((backdrop-filter: blur(".concat(blur, "px)) or (-webkit-backdrop-filter: blur(").concat(blur, "px)))"), {
        root: {
          backgroundColor: palette.type === _constants.themeMode.LIGHT ? '#F0F0F0F0' : '#0F0F0FF0'
        }
      }), "@supports (backdrop-filter: blur(".concat(blur, "px)) or (-webkit-backdrop-filter: blur(").concat(blur, "px))"), {
        root: {
          backdropFilter: "blur(".concat(blur, "px)"),
          backgroundColor: (0, _typeof2["default"])(background) === 'object' ? background[palette.type] : background
        }
      });
    })(_Backdrop["default"]);
  }, [blur]);
  return /*#__PURE__*/_react["default"].createElement(StyledBackdrop, props);
};
var _default = exports["default"] = FrostedBackdrop;
//# sourceMappingURL=index.js.map